import React, { useEffect } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const BVUserGeneratedContent = (props) => {
    const { ppId } = props;

    /* istanbul ignore next */
    useEffect(() => {
        if (window.crl8) {
            window.crl8.ready(() => {
                window.crl8.createExperience('product');
            });
        }

        return () => {
            if (window.crl8) {
                window.crl8.ready(() => {
                    window.crl8.destroyExperience('product');
                });
            }
        };
    }, []);

    return (
        <div
            data-crl8-container-id="product"
            data-crl8-filter={`productId:${ppId}`}
            data-crl8-lazy-load-experience="true"
            className={`${dt(['pb-6'])}`}
        />
    );
};

export default BVUserGeneratedContent;
